
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/richest-people-in-fashion",
      function () {
        return require("private-next-pages/richest-people-in-fashion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/richest-people-in-fashion"])
      });
    }
  